import type { FaireProductEntity } from "../../entity_types/product";

export const p_agm6bquzqj: FaireProductEntity = {
  token: "p_agm6bquzqj",
  type: "product",
  name: "Up North Minnesota Shaped Sticker",
  brandName: "Fuzzy Loon Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/4600bd23dc24d3ae513d293adbc664b8d4fa2ab761957bd05b9115abda65072a.jpeg",
  priceDollars: 1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ef984654237c8ed908f4a7de51c97c08852b0933f224c36ba7b8b208e6ee3ce8.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
